import {find, last} from 'lodash';
import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {ContactCardPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {IconButton} from '../../../../../libs/shared/ui/src/components/buttons/iconButton';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {useAppDispatch, useAppSelector} from '../../../../helpers/appReduxHelpers';
import {VisualContactModel} from '../../../../models/api/visualContactModel';
import {getFirstContactEntryPoint} from '../../../../store/data/applications/applicationsSelectors';
import {activateContactEntryPointAction} from '../../../../store/data/applications/selectedSideFrameIdActions';

/*
 * Props.
 */

interface ContactCardFooterCallActionProps {
  panelId: ContactCardPanelId;
  visualContact: VisualContactModel;
}

/*
 * Component.
 */

export const ContactCardFooterCallAction: FC<ContactCardFooterCallActionProps> = (props) => {
  const theme = useUserTheme();
  const {panelId, visualContact} = props;
  const dispatch = useAppDispatch();

  const contactEntryPoint = useAppSelector(getFirstContactEntryPoint);
  const firstPhoneContactUid = find(visualContact.card?.contactUids, (uid) => uid.includes('phone'));
  const phoneHandle = last(firstPhoneContactUid?.split('#'));

  const shouldShowCallAction = contactEntryPoint && phoneHandle;

  if (!shouldShowCallAction) {
    return null;
  }

  return (
    <IconButton
      iconName="phone"
      color={theme.greys.shade70}
      hoverColor={theme.greys.shade80}
      placement="top"
      isDisabled={!contactEntryPoint}
      label={<Trans id="contact-card-footer-action-call">Call</Trans>}
      onClick={() => {
        dispatch(activateContactEntryPointAction(contactEntryPoint, phoneHandle, panelId));
      }}
    />
  );
};
